var render = function render(){var _vm=this,_c=_vm._self._c;return _c('settings-wrapper',{attrs:{"title":"Space settings","section":"Secrets"}},[_c('secrets-listing',{attrs:{"level":2,"entity-id":_vm.activeSpaceId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }